import { DSModal } from "@components/design-system/organisms";
import { Link } from "react-router";

/**
 * Shown when signup is refused because the email's domain belongs to an
 * organization that provisions Scribenote accounts itself.
 *
 * Triggered by the ENTERPRISE_DOMAIN_BLOCKED error code rather than the
 * message text, so the copy can change without touching this.
 */
export const EnterpriseBlockedModal = ({
  isOpen,
  onClose,
  email,
}) => {
  const domain = email?.split("@")[1];

  return (
    <DSModal
      isOpen={isOpen}
      onClose={onClose}
      title="Your organization manages Scribenote accounts"
      dataTestId="enterprise-blocked-modal"
      actions={[
        {
          label: "Got it",
          variant: "primary",
          onClick: onClose,
          dataTestId: "enterprise-blocked-acknowledge",
        },
      ]}
    >
      <p>
        Accounts for{" "}
        <span className="font-bold">
          {domain || "your organization"}
        </span>{" "}
        are created by an administrator within your organization. Ask
        them to add you to your team, and they&apos;ll get you set up.
      </p>
      <p className="text-secondary text-sm">
        Already have a Scribenote account?{" "}
        <Link to="/auth/login" className="text-brand underline">
          Sign in
        </Link>{" "}
        or{" "}
        <Link to="/forgot_password" className="text-brand underline">
          reset your password
        </Link>
        .
      </p>
    </DSModal>
  );
};
